import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// View UI Plus
import ViewUIPlus from 'view-ui-plus'
import 'view-ui-plus/dist/styles/viewuiplus.css'

// Global styles
import './assets/styles/common.scss'

const app = createApp(App)
app.use(router)
app.use(store)
app.use(ViewUIPlus)
app.mount('#app')
